import { ColumnType } from "antd/lib/table";
import { compact } from "lodash";
import { EMPTY } from "constants/common";
import { AiccScenarioCategory } from "types/model/aiccLearningAssets";
import getActionColumn, { AssetColumnHandlers } from "../getActionColumn";

const getColumns = ({ isEditable, canDelete, onEdit, onDelete }: AssetColumnHandlers<AiccScenarioCategory>) =>
  compact<ColumnType<AiccScenarioCategory>>([
    {
      title: "Category",
      dataIndex: "name",
      key: "name",
      width: 240,
      render: (name) => name || EMPTY,
    },
    {
      title: "Category Description",
      dataIndex: "description",
      key: "description",
      width: 480,
      render: (description) => description || EMPTY,
    },
    isEditable && getActionColumn<AiccScenarioCategory>({ canDelete, onEdit, onDelete }),
  ]);

export default getColumns;
